module.exports = __webpack_public_path__ + "static/media/icon_linkedin.d173410d.svg";